export default "__VITE_ASSET__Bu4hWZoC__"